module.exports = __webpack_public_path__ + "static/instalaciones-4-0036526ec361d968042d40cfc1965679.jpg";